import moment from 'moment';
import React from 'react';
import Checkbox from "../../../../shared/forms/Checkbox";
import './SignatureResponse.scss';

const SignatureResponse = (props) => {
  // ----------------------
  // Methods
  // ----------------------

  function handleInput() {
    const valueObject = !props.value.isChecked
      ? { isChecked: true, signedAt: new Date() }
      : { isChecked: false, signedAt: null };
    props.onValueChange(valueObject);
  }

  // ----------------------
  // Render
  // ----------------------

  return (
      <div className='signature-response'>
        <Checkbox
          label={props.prompt}
          name={props.name}
          onChange={() => handleInput()}/>
        {props.value.signedAt && (
          <label>{moment().format('HH:mm on MMM D, YYYY')}</label>
        )}
      </div>
  );
}

export default SignatureResponse;

